import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../_common/components/Footer/Footer";

export const TransfersFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.transfers.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
